import React from 'react'
import { Button } from '@mui/material'
import PropTypes from 'prop-types'

import { BUTTON } from '../../styles/buttons'

/**
 * @param {{value: number, onClick: (n: number) => void, variant: string,
 *        color: string, label: string}} props
 */
function TabButton(props) {
  return (
    <Button
      variant={props.variant}
      onClick={() => props.onClick(props.value)}
      style={{
        padding: '10px',
        fontSize: '12px',
        ...BUTTON.default,
        color: props.color,
        width: '50%',
        whiteSpace: 'initial'
      }}
    >
      {props.label}
    </Button>
  )
}

TabButton.propTypes = {
  variant: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  value: PropTypes.number,
  label: PropTypes.string,
  sx: PropTypes.object
}

export default TabButton
